import { keepPreviousData, skipToken, useQuery } from '@tanstack/react-query'

import { useAuth } from '@/lib/auth'

import type { ReportQueryDefinition } from '../lib/report-query'
import { reportPreviewApi, type ReportPagination } from './report-preview-api'

export const reportPreviewKey = (userId: string, entityId: string, definition: ReportQueryDefinition | null) =>
  ['report-run', 'preview', userId, entityId, definition]

export function usePreviewReport(entityId: string | null, definition: ReportQueryDefinition | null, rawQuery: string | null = null, pagination: ReportPagination | null = null, keepPrevious = false) {
  const userId = useAuth().user?.userId
  return useQuery({
    queryKey: [...reportPreviewKey(userId ?? '', entityId ?? '', definition), rawQuery, pagination],
    queryFn:
      userId === undefined || (definition === null && rawQuery === null)
        ? skipToken
        : () => reportPreviewApi.preview(entityId, definition, rawQuery, pagination),
    placeholderData: keepPrevious ? keepPreviousData : undefined,
    retry: false,
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
